module.exports = __webpack_public_path__ + "static/img/sustainable-performance_01_2025.cedcbdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/sustainable-performance_01_2025.jpg
// module id = ST61
// module chunks = 100